import React from 'react'
import { BaseView, BaseText } from '@/components/base'

interface RequestNoteProps {
  note?: string
}

export const RequestNote: React.FC<RequestNoteProps> = ({ note }) => {
  if (!note) return null

  return (
    <BaseView px={16}>
      <BaseText
        fontSize={16}
        fontFamily="regular"
        color="label.default"
        textAlign="center"
        style={{
          lineHeight: '24px',
        }}
      >
        {note}
      </BaseText>
    </BaseView>
  )
}
